/*
 *
 * CarNumberScanner constants
 *
 */

export const CONNECT_TO_CAR_NUMBER_SCANNER_SERVICE = 'claris-vnext/CarNumberScanner/CONNECT_TO_CAR_NUMBER_SCANNER_SERVICE';
export const DISCONNECT_TO_CAR_NUMBER_SCANNER_SERVICE = 'claris-vnext/CarNumberScanner/DISCONNECT_TO_CAR_NUMBER_SCANNER_SERVICE';
export const SCAN_CAR_NUMBER = 'claris-vnext/CarNumberScanner/SCAN_CAR_NUMBER';
